import { AxiosProgressEvent } from "axios";
import HttpService from "core/services/Http/HttpService";
import axios from "axios";

export interface Theme {
  id: number;
  title: string;
  description: string;
  created_at: string;
  updated_at: string;
  featured: boolean;
}

export interface ThemesResponse {
  results: Theme[];
  count: number;
}

export interface ThemeFormData {
  title: string;
  description: string;
  featured: boolean;
}

export interface FieldOptions {
  useCaseTypes: string[];
  companies: string[];
  industries: string[];
  impacts: string[];
  technologies: string[];
  countries: string[];
  tools: string[];
}

export class ContentHttpService {

  static async validateUrl(url: string) {
    var service = new HttpService();
    var response;
    response = await service.get(`/content/url-validation?url=${url}`);
    return response.data;
  }

  static async loadReport(reportId: number | undefined) {
    if (!reportId) return null;
    
    var service = new HttpService();
    var response;

    response = await service.get(`/content/reports/${reportId}/`);

    if(response.statusCode==200){
      return response.data;
    }

    return null;
  }

  static async loadReports() {

      var service = new HttpService();
      var response;


      response = await service.get(`/content/reports/`);

      if(response.statusCode==200){
        return response.data;
      }

      return response
  }

  

  static async loadInsights() {

      var service = new HttpService();
      var response;


      response = await service.get(`/content/insights/`);

      if(response.statusCode==200){
        return response.data;
      }

      return response
  }


  static async deleteContent(contentId:number) {

      var service = new HttpService();
      var response;

      response = await service.delete(`/content/${contentId}`);

      return response
  }


  static async loadContents({category=null,searchQuery='/',page=1, pageSize=30}) {

      var service = new HttpService();
      var response;

      var query = `?category=${category}&page=${page}&size=${pageSize}&query=${searchQuery}`

      response = await service.get(`/content/${query}`);

      if(response.statusCode==200){
        return response.data;
      }

      return response
  }


  static async loadContent(contentId:number) {

    var service = new HttpService();
    var response;

    response = await service.get(`/content/${contentId}`);

    if(response.statusCode==200){
      return response.data;
    }

    return response
}

  static async generateReport(data: { query: string; prompt_id?: number}) {
    var service = new HttpService();
    var response:any;

    response = await service.post('/content/report-generation/', data);

    if(response.statusCode === 200 || response.statusCode === 201) {
      return response.data;
    }

    return response;
  }

  static async getPrompts() {
    var service = new HttpService();
    var response : any;

    response = await service.get('/content/prompts/');

    if(response.statusCode==200){
      return response.data;
    }

    return response;
  }

  static async createPrompt(data: { title: string; content: string; json_structure?: string }) {
    var service = new HttpService();
    var response;

    response = await service.post('/content/prompts/', data);

    if(response.statusCode==200 || response.statusCode==201){
      return response.data;
    }

    return response;
  }

  static async deleteReport(reportId: number) {
    var service = new HttpService();
    var response;
    response = await service.delete(`/content/reports/${reportId}/`);
    return response.data;
  }

  static async loadSDLCUseCases(report_id?: number, searchQuery?: string, page: number = 1, pageSize: number = 10) {
    var service = new HttpService();
    var response;
    let endpoint = report_id 
      ? `/content/sdlc-use-cases/?report_id=${report_id}`
      : `/content/sdlc-use-cases/`;
    
    const params = new URLSearchParams();
    
    params.append('page', page.toString());
    params.append('size', pageSize.toString());
    
    endpoint += endpoint.includes('?') ? `&${params.toString()}` : `?${params.toString()}`;

    if (searchQuery) {
      endpoint += searchQuery;
    }
    
    response = await service.get(endpoint);
    if(response.statusCode==200){
      return response.data;
    }
    return response;
  }

  static async loadAISDLCUseCases(report_id?: number, searchQuery?: string, page: number = 1, pageSize: number = 10) {
    var service = new HttpService();
    var response;
    let endpoint = report_id 
      ? `/content/ai-sdlc-use-cases/?report_id=${report_id}`
      : `/content/ai-sdlc-use-cases/`;
    
    const params = new URLSearchParams();
    
    params.append('page', page.toString());
    params.append('size', pageSize.toString());
    
    endpoint += endpoint.includes('?') ? `&${params.toString()}` : `?${params.toString()}`;

    if (searchQuery) {
      endpoint += searchQuery;
    }
    
    response = await service.get(endpoint);
    if(response.statusCode==200){
      return response.data;
    }
    return response;
  }

  static async loadRetailUseCases(report_id?: number, searchQuery?: string, page: number = 1, pageSize: number = 10) {
    var service = new HttpService();
    var response;
    let endpoint = report_id 
      ? `/content/retail-use-cases/?report_id=${report_id}`
      : `/content/retail-use-cases/`;
    
    const params = new URLSearchParams();
    
    params.append('page', page.toString());
    params.append('size', pageSize.toString());
    
    endpoint += endpoint.includes('?') ? `&${params.toString()}` : `?${params.toString()}`;

    if (searchQuery) {
      endpoint += searchQuery;
    }
    
    response = await service.get(endpoint);
    if(response.statusCode==200){
      return response.data;
    }
    return response;
  }

  static async generateSDLCReport() {
    var service = new HttpService();
    var response;
    response = await service.post(`/content/sdlc-report-generation/`, {});
    if(response.statusCode==200){
      return response.data;
    }
    return response;
  }

  static async generateAISDLCReport() {
    var service = new HttpService();
    var response;
    response = await service.post(`/content/ai-sdlc-report-generation/`, {});
    if(response.statusCode==200){
      return response.data;
    }
    return response;
  }

  static async loadReportThoughts(reportId: string | undefined) {
    var service = new HttpService();
    var response;

    response = await service.get(`/content/reports/${reportId}/thoughts/`);

    if(response.statusCode==200){
      return response.data;
    }

    return response;
  }

  static async initializeStream(): Promise<any> {
    var service = new HttpService();
    var response;

    response = await service.post('/content/stream/', {});

    if(response.statusCode === 200 || response.statusCode === 201) {
      return response.data as any;
    }

    throw new Error('Failed to initialize stream');
  }

  static async loadUseCases(themeId?: number, searchQuery?: string, page: number = 1, pageSize: number = 30) {
    var service = new HttpService();
    const params = new URLSearchParams();
    var query = '';
    if (themeId) {
      query = `theme_id=${themeId}`;
    }
    if (searchQuery) {
      query += `${searchQuery}`;
    }

    if (query) {
      query += `&page=${page}&size=${pageSize}`;
    }
    else {
      query = `page=${page}&size=${pageSize}`;
    }



    const response = await service.get(`/content/use-cases/?${query}`);
    if(response.statusCode === 200) {
      return response.data;
    }
    throw new Error('Failed to load use cases');
  }

  static async generateUseCaseReport(themeId?: number) {
    var service = new HttpService();
    var response;
    response = await service.post(`/content/report-generation/`, {
      // report_type: 'structured',
      theme_id: themeId
    });
    if(response.statusCode==200){
      return response.data;
    }
    return response;
  }

  static async getThemes(in_featured?: boolean) {
    var service = new HttpService();
    var response;

    if(in_featured !== undefined){
      response = await service.get(`/content/themes/?featured=${in_featured}`);
    }else{
      response = await service.get(`/content/themes/`);
    }

    if(response.statusCode==200){
      return response.data;
    }
    return response;
  }

  static async loadThemes(page: number, pageSize: number): Promise<any> {
    var service = new HttpService();
    var response = await service.get(`/content/themes/?page=${page}&page_size=${pageSize}`);
    if (response.statusCode === 200) {
      return response.data;
    }
    throw new Error('Failed to load themes');
  }

  static async saveTheme(data: ThemeFormData, id?: number): Promise<any> {
    var service = new HttpService();
    var response;
    
    if (id) {
      response = await service.put(`/content/themes/${id}/`, data);
    } else {
      response = await service.post('/content/themes/', data);
    }

    if (response.statusCode === 200 || response.statusCode === 201) {
      return response.data;
    }
    throw new Error('Failed to save theme');
  }

  static async deleteTheme(id: number): Promise<void> {
    var service = new HttpService();
    var response = await service.delete(`/content/themes/${id}/`);
    if (response.statusCode !== 204) {
      throw new Error('Failed to delete theme');
    }
  }

  static async stopReportGeneration(themeId?: number) {
    var service = new HttpService();
    const response = await service.post(`/content/reports/${themeId}/stop/`, {});
    return response.data;
  }

  static async findReportByTheme(themeId: number) {
    var service = new HttpService();
    const response = await service.get(`/content/reports/theme/${themeId}/`);
    return response.data;
  }

  static async getFieldOptions(themeId?: number): Promise<FieldOptions> {
    var service = new HttpService();
    const query = themeId ? `?theme_id=${themeId}` : '';


    var response = await service.get(`/content/field-options/${query}`);
    
    if(response.statusCode === 200) {
      return response.data as FieldOptions;
    }
    throw new Error('Failed to load field options');
  }

  static async savePrompt(data: { title: string; content: string; json_structure?: string; id?: number }, id?: number): Promise<any> {
    var service = new HttpService();
    var response;
    if (id) {
      response = await service.put(`/content/prompts/${id}/`, data);
    } else {
      response = await service.post('/content/prompts/', data);
    }
    if (response.statusCode === 200 || response.statusCode === 201) {
      return response.data;
    }
    throw new Error('Failed to save prompt');
  }

  static async deletePrompt(id: number): Promise<void> {
    var service = new HttpService();
    var response = await service.delete(`/content/prompts/${id}/`);
    if (response.statusCode !== 204) {
      throw new Error('Failed to delete prompt');
    }
  }
}